module.exports = __webpack_public_path__ + "static/media/gray-light-star.17a95aed.svg";